import { BASE_URL } from "../config";

export const IDENTIFICATION_ACTION = {
  CHECK_IN: "checkIn",
  CHECK_OUT: "checkOut",
  MANAGE: "manage",
  UNSCHEDULED: "unscheduled",
  NOT_FOUND: "notFound",
  NEED_HELP: "needHelp",
};

export async function recordIdentificationAction(identificationId, { action, status, shiftId } = {}) {
  const id = Number(identificationId);
  if (!Number.isFinite(id) || id <= 0) return false;
  if (!action && !status) return false;

  try {
    const res = await fetch(`${BASE_URL}/api/face/update-identification-status`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        identificationId: id,
        ...(action ? { action } : {}),
        ...(status ? { status } : {}),
        ...(shiftId != null ? { shiftId } : {}),
      }),
    });
    const data = await res.json().catch(() => ({}));
    return res.ok && data?.success !== false;
  } catch (err) {
    console.error("Failed to record identification action:", err);
    return false;
  }
}
